import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  DrawerContext,
  IconRegularClose,
  ReactFCC,
} from '@notino/react-styleguide';
import { IIconProps } from '@notino/react-styleguide/dist/types/components/atoms/Icons/utils/model';

import messages from '@containers/WishList/messages';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { trackRefresh } from '../../tracking';

import {
  DrawerTitleContainer,
  DrawerIconWrapper,
  DrawerDragger,
  StyledDrawerTitle,
  DrawerTitleWrapper,
  CloseIconButton,
  RefreshButton,
} from './styled';

export interface IDrawerTitleProps {
  name: string | JSX.Element;
  titleIcon?: ReactFCC<IIconProps>;
  onRefreshButtonClick?: () => void;
  afterClose?: () => void;
}

export const DrawerTitle = ({
  name,
  titleIcon: CloseIconElement = IconRegularClose,
  onRefreshButtonClick,
  afterClose,
}: IDrawerTitleProps) => {
  const { closeDrawer } = DrawerContext.useDrawerContext();

  const { getTimeFromInit } = useTrackingContext();

  const onClick = () => {
    onRefreshButtonClick?.();
    trackRefresh(getTimeFromInit());
  };

  return (
    <DrawerTitleContainer data-testid="drawer-title">
      <DrawerIconWrapper>
        <DrawerDragger />
      </DrawerIconWrapper>
      <DrawerTitleWrapper>
        <CloseIconButton
          onClick={() => {
            closeDrawer();
            afterClose?.();
          }}
        >
          <CloseIconElement
            color="icon.primary"
            width="1.25rem"
            height="1.25rem"
          />
        </CloseIconButton>

        <StyledDrawerTitle>{name}</StyledDrawerTitle>
        {onRefreshButtonClick && (
          <RefreshButton onClick={onClick}>
            <FormattedMessage {...messages.refreshButton} />
          </RefreshButton>
        )}
      </DrawerTitleWrapper>
    </DrawerTitleContainer>
  );
};
